import { render } from "./listeDetails.vue?vue&type=template&id=5726eb73&scoped=true"
import script from "./listeDetails.vue?vue&type=script&lang=js"
export * from "./listeDetails.vue?vue&type=script&lang=js"

import "./listeDetails.vue?vue&type=style&index=0&id=5726eb73&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5726eb73"]])

export default __exports__